import { render } from "./PasswordResetView.vue?vue&type=template&id=5e6b1d4a&ts=true"
import script from "./PasswordResetView.vue?vue&type=script&lang=ts"
export * from "./PasswordResetView.vue?vue&type=script&lang=ts"

import exportComponent from "/var/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__